import {AccessTime} from '@material-ui/icons';
import React from 'react';

interface IExpireYellowIconProps {
  disabled?: boolean;
}

export function ExpireYellowIcon({disabled}: IExpireYellowIconProps) {
  return <AccessTime fontSize="small" style={{opacity: disabled ? 0.3 : 1, color: '#FFD700', flexShrink: 0}} />;
}
